import { Skeleton } from "antd";
import {  ReactNode } from "react";

const AdvertInfoesSkeleton = (props:{loading:boolean,children:ReactNode}) => {
  return (
    <>
    {
        props.loading?<>
        
    <div className="!flex gap-4 items-center !h-full">
      <Skeleton.Avatar active size={70} shape="square" />
      <div>
        <div>
        <Skeleton.Input active size="small" style={{ width: 100 }} />

        </div>
        <div>

        <Skeleton.Input active size="small" style={{ width: 150, marginTop: 8 }} />
        </div>
        <div>

        <Skeleton.Input className="" active size="small" style={{ width: 200, marginTop: 8 }} />
        </div>
      </div>
    </div>
        </>:<>
        {props.children}
        </>
    
    }
    </>
  );
};

export default AdvertInfoesSkeleton